module.exports = __webpack_public_path__ + "static/resource-work-from-home-55205b19af82d7bfff186f2f136a7a63.png";